import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/review-company-logo.svg")